var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.831628 0.291687L10.1684 0.291687C10.3335 0.292388 10.4948 0.34268 10.6317 0.436203C10.7687 0.529726 10.8752 0.66228 10.9377 0.817103C11.0003 0.971926 11.0162 1.14207 10.9833 1.30601C10.9504 1.46995 10.8702 1.62033 10.753 1.73814L6.09294 6.45815C6.01531 6.53743 5.92294 6.60036 5.82117 6.6433C5.7194 6.68624 5.61025 6.70835 5.5 6.70835C5.38975 6.70835 5.2806 6.68624 5.17883 6.6433C5.07706 6.60036 4.98469 6.53743 4.90706 6.45815L0.247038 1.73814C0.129767 1.62033 0.0496192 1.46995 0.0167275 1.30601C-0.0161642 1.14207 -0.000322459 0.971926 0.0622501 0.817103C0.124823 0.66228 0.231316 0.529726 0.368263 0.436203C0.505211 0.34268 0.666462 0.292388 0.831628 0.291687Z",
    fill: "#3747DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.3134664cec97183f0970641b51e99f28.svg";
export { ForwardRef as ReactComponent };